export var PriceListStatus;
(function (PriceListStatus) {
    PriceListStatus["DRAFT"] = "draft";
    PriceListStatus["PUBLISHED"] = "published";
})(PriceListStatus || (PriceListStatus = {}));
//# sourceMappingURL=price-list-status.enum.js.map